/* eslint-disable complexity */
import { MT_MODULES } from '~/components/CommonConstants';
import { useUserAuth } from '~/components/Auth';

const L3_MICO_MIGRATION_MODULES = [
  MT_MODULES.ONE_TO_ONE_COACHING,
  MT_MODULES.SCREEN_CAPTURE_COACHING,
  MT_MODULES.TASK_EVALUATION_COACHING,
  MT_MODULES.VIDEO_PITCH_COACHING,
  MT_MODULES.VOICE_OVER_PPT_COACHING,
  MT_MODULES.PERFORMANCE_EVALUATION_COACHING,
  MT_MODULES.COMPETENCY_ASSESSMENT,
];

const useL2L3MigrationPrefix = (moduleType: string) => {
  const {
    tempFeatureConfig: {
      isChecklistL3MigrationEnabled = false,
      isQuestL3MigrationEnabled = false,
    } = {},
  } = useUserAuth();

  const type = Number(moduleType);

  if (
    L3_MICO_MIGRATION_MODULES.includes(type as 15 | 13 | 12 | 11 | 10 | 9) ||
    (isChecklistL3MigrationEnabled && MT_MODULES.CHECKLIST === type) ||
    (isQuestL3MigrationEnabled && MT_MODULES.REINFORCEMENT === type)
  ) {
    return '/new';
  }

  return '';
};

export default useL2L3MigrationPrefix;
